export const components = {
  'Facial recognition': 'Reconhecimento facial',
  Payment: 'Pagamento',
  Summary: 'Resumo',
};
